import styles from './icon.module.scss';
import MaterialIcon from '@mui/material/Icon';
import MaterialSvgIcon from '@mui/material/SvgIcon';

/* eslint-disable-next-line */
export interface IconProps {
  // baseClassName?: string,
  children: any,
  // classes?: object,
  color?: 'inherit' | 'action' | 'disabled' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning',
  // component?: any,
  fontSize?: 'inherit' | 'large' | 'medium' | 'small',
  sx?: any,
  className?: string
}

export interface SvgIconProps {
  children: any,
  // classes?: object,
  color?: 'inherit' | 'action' | 'disabled' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning',
  // component?: any,
  fontSize?: 'inherit' | 'large' | 'medium' | 'small',
  // htmlColor?: string,
  // shapeRendering?: string,
  sx?: any,
  // titleAccess?: string,
  // viewBox?: string,
  className?: string
}

export function Icon(props: IconProps) {
  return (
    <MaterialIcon
      color={props.color}
      fontSize={props.fontSize}
      className={props.className}
      sx={props.sx}>
      {props.children}
    </MaterialIcon>
  );
}

export function SvgIcon(props: SvgIconProps) {
  return (
    <MaterialSvgIcon
      color={props.color}
      fontSize={props.fontSize}
      className={props.className}
      sx={props.sx}>
      {props.children}
    </MaterialSvgIcon>
  );
}

export default Icon;